export default "__VITE_ASSET__eGEp8xsI__"